"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const MatchingFruits = ({ onScore }) => {
  const [matches, setMatches] = useState({})

  const fruits = [
    { id: "strawberries", emoji: "🍓", count: 3, correctNumber: 3 },
    { id: "apples", emoji: "🍎", count: 4, correctNumber: 4 },
    { id: "cherries", emoji: "🍒", count: 9, correctNumber: 9 },
    { id: "raspberries", emoji: "🫐", count: 2, correctNumber: 2 },
    { id: "pears", emoji: "🍐", count: 5, correctNumber: 5 },
  ]

  const numbers = [3, 9, 4, 7, 2]

  const makeMatch = (fruitId, number) => {
    const newMatches = { ...matches, [fruitId]: number.toString() }
    setMatches(newMatches)

    const fruit = fruits.find((f) => f.id === fruitId)
    if (fruit && fruit.correctNumber === number) {
      onScore(15)
    }
  }

  return (
    <div className="lesson-card card-pink">
      <h2 className="lesson-title" style={{ color: "#be185d" }}>
        Устанавливаем соответствие 🍓
      </h2>

      <p style={{ fontSize: "1.25rem", textAlign: "center", marginBottom: "24px" }}>
        Сопоставь фрукты с правильными числами!
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {fruits.map((fruit) => (
          <div
            key={fruit.id}
            style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "24px", alignItems: "center" }}
          >
            {/* Фрукты */}
            <div
              style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                border: "2px solid #e5e7eb",
                textAlign: "center",
              }}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "4px" }}>
                {Array.from({ length: fruit.count }, (_, i) => (
                  <div key={i} style={{ fontSize: "1.875rem" }}>
                    {fruit.emoji}
                  </div>
                ))}
              </div>
            </div>

            {/* Кнопки выбора чисел */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px" }}>
              {numbers.map((number) => (
                <button
                  key={`${fruit.id}-${number}`}
                  onClick={() => makeMatch(fruit.id, number)}
                  style={{
                    fontSize: "1.25rem",
                    padding: "12px",
                    border: "2px solid",
                    borderRadius: "4px",
                    backgroundColor: matches[fruit.id] === number.toString() ? "#22c55e" : "#fef3c7",
                    color: matches[fruit.id] === number.toString() ? "white" : "#374151",
                    borderColor: matches[fruit.id] === number.toString() ? "#16a34a" : "#f59e0b",
                    cursor: "pointer",
                  }}
                >
                  {number}
                </button>
              ))}
            </div>

            {/* Абакус */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ transform: "scale(0.8)" }}>
                <AbacusDisplay value={matches[fruit.id] ? Number.parseInt(matches[fruit.id]) : 0} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MatchingFruits
